import { Clock, User, Users, Link2, Sparkles, Smartphone } from 'lucide-react';
import { STATE_META, stateStyle, elapsed, money, displayName, people, phones } from './tableStates';

const Meta = ({ unit, now, showAmount, compact }) => {
  if (unit.state === 'reserved' && unit.reservation) {
    const r = unit.reservation;
    return (
      <div className="text-[11px] space-y-0.5">
        <div className="flex items-center gap-1"><Clock className="w-3 h-3" />{r.time} · en {Math.max(0, r.minutes_until)} min</div>
        {!compact && <div className="flex items-center gap-1"><User className="w-3 h-3" />{r.customer_name}</div>}
        <div className="flex items-center gap-1"><Users className="w-3 h-3" />{people(r.party_size)}</div>
      </div>
    );
  }
  if (!unit.session_id) {
    return <div className="text-[11px] flex items-center gap-1"><Users className="w-3 h-3" />Capacidad {unit.capacity}</div>;
  }
  return (
    <div className="text-[11px] space-y-0.5">
      <div className="flex items-center gap-1" data-testid={`table-elapsed-${unit.unit_id}`}><Clock className="w-3 h-3" />{elapsed(unit.opened_at, now)}</div>
      {!compact && <div className="flex items-center gap-1" data-testid={`table-waiter-${unit.unit_id}`}><User className="w-3 h-3" />{unit.waiter_name || 'Sin mozo'}</div>}
      <div className="flex items-center gap-1" data-testid={`table-guests-${unit.unit_id}`}><Users className="w-3 h-3" />{people(unit.guest_count)}</div>
      <div className="flex items-center gap-1" data-testid={`table-devices-${unit.unit_id}`}><Smartphone className="w-3 h-3" />{phones(unit.devices || 0)}</div>
      {showAmount && unit.total !== null && unit.total !== undefined && (
        <div className="font-mono text-xs pt-1 mt-1 border-t border-white/30" data-testid={`table-amount-${unit.unit_id}`}>{money(unit.total)}</div>
      )}
    </div>
  );
};

export const TableCard = ({ unit, now, showAmount, selected, onClick, onDoubleClick, onClean, compact = false, style }) => {
  const m = STATE_META[unit.state] || STATE_META.free;
  const Icon = unit.group_unit_ids?.length ? Link2 : m.icon;
  return (
    <button type="button" onClick={onClick} onDoubleClick={onDoubleClick}
      data-testid={`table-card-${unit.unit_id}`} data-state={unit.state} data-state-swatch
      className={`relative text-left rounded-2xl p-3 flex flex-col justify-between shadow-md transition-transform duration-150 hover:-translate-y-0.5 ${m.blink ? 'table-blink' : ''} ${selected ? 'ring-4 ring-offset-2 ring-foreground/70' : ''} ${compact ? 'min-h-[110px] w-[150px]' : 'min-h-[150px]'}`}
      style={{ ...stateStyle(unit.state), ...style }}>
      {unit.pending_confirmation && (
        <span className="absolute -top-2.5 left-3 bg-amber-400 text-black text-[10px] font-bold px-2 py-0.5 rounded-full" data-testid={`table-pending-badge-${unit.unit_id}`}>
          Por confirmar
        </span>
      )}
      {unit.group_unit_ids?.length > 0 && (
        <span className="absolute -top-2.5 right-3 bg-foreground text-background text-[10px] font-bold px-2 py-0.5 rounded-full" data-testid={`table-group-badge-${unit.unit_id}`}>
          {unit.group_unit_ids.length} mesas juntas
        </span>
      )}
      <div className="flex justify-between items-start gap-2">
        <div className="min-w-0">
          <div className="font-heading font-bold text-xl leading-tight truncate">{displayName(unit)}</div>
          <div className="text-[10px] uppercase tracking-wider font-bold opacity-95 mt-0.5" data-testid={`table-state-${unit.unit_id}`}>{m.label}</div>
        </div>
        <div className="w-8 h-8 rounded-lg grid place-items-center shrink-0" style={{ background: m.outline ? 'rgba(124,106,70,.12)' : 'rgba(255,255,255,.2)' }}>
          <Icon className="w-4 h-4" />
        </div>
      </div>
      <Meta unit={unit} now={now} showAmount={showAmount} compact={compact} />
      {unit.state === 'to_clean' && onClean && (
        <span role="button" tabIndex={0} data-testid={`table-clean-btn-${unit.unit_id}`}
          onClick={(e) => { e.stopPropagation(); onClean(unit); }}
          className="mt-2 inline-flex items-center gap-1 bg-white text-gray-700 text-[11px] font-bold px-2 py-1 rounded-full w-max">
          <Sparkles className="w-3 h-3" />Marcar limpia
        </span>
      )}
    </button>
  );
};
